import { render, staticRenderFns } from "./MenuChart.vue?vue&type=template&id=7fc7ce89&"
import script from "./MenuChart.vue?vue&type=script&lang=js&"
export * from "./MenuChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports